/*
 * 🔒 A site photo's part of the upload window on a Deal (decisions 6380, 6382; row T2916): the unit field with the
 * Deal's own units beside it, the five coaching prompts, and each landed photo's checks. Every value is a token.
 */
.photo {
  display: grid;
  gap: var(--space-2);
}

.units {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-1);
}

.unitsLabel {
  color: var(--text-muted);
  font-size: var(--font-size-small);
}

.coach {
  margin: 0;
  padding-inline-start: var(--space-4);
  color: var(--text-muted);
  font-size: var(--font-size-small);
}

.coachTitle {
  margin: 0;
  font-weight: var(--font-weight-semibold);
}

.checks {
  display: grid;
  gap: var(--space-1);
  margin: 0;
  padding: 0;
  list-style: none;
}

.check {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-medium);
  background: var(--status-warning-bg);
  color: var(--status-warning-text);
}

.clear {
  color: var(--status-good-text);
  font-size: var(--font-size-small);
}

/* 🔒 Decision 11301: one waiting file's own line in the upload window, its name box and its date box side by side, wrapping where narrow. */
.line {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: var(--space-2);
}
